<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ form.id ? "Editar Tipo Permiso" : "Crear Tipo Permiso" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex md12>
								<v-autocomplete
									:items="tipo_permiso"
									v-model="form.id_parametro_tipo_permiso"
									:item-value="val => parseInt(val.id)"
									item-text="valor"
									:rules="$validate(['required'])"
									label="Tipo permiso"
									
								></v-autocomplete>
							</v-flex> -->
              <v-flex md12 xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  label="Tipo de permiso"
                  v-model="form.descripcion"
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  label="Tolerancia"
                  type="time"
                  v-model="form.tolerancia"
                ></v-text-field>
              </v-flex>
			   <v-flex md12 xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  label="Plazo"
                  type="number"
                  v-model.number="form.plazo"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex md6>
								<v-text-field
									label="Tiempo mínimo (hrs.)"
									v-model="form.tiempo_maximo"
									:rules="$validate(['required'])"
									required
								></v-text-field>
							</v-flex>
							<v-flex md6>
								<v-text-field
									label="Tiempo máximo (hrs.)"
									v-model="form.tiempo_minimo"
									:rules="$validate(['required'])"
									required
								></v-text-field>
							</v-flex> -->
              <v-flex md6 xs12>
                <p>Refrigerio</p>
                <v-radio-group v-model="form.refrigerio" row>
                  <v-radio label="Sí" :value="1"></v-radio>
                  <v-radio label="No" :value="0"></v-radio>
                </v-radio-group>
              </v-flex>
              <!-- <v-flex md6 xs12>
									<p>Elaborado por:</p>
									<v-radio-group v-model="form.id_parametro_elaborado" row>
									<v-radio label="Servidor Público" :value="91"></v-radio>
									<v-radio label="Recursos Humanos" :value="92"></v-radio>
									</v-radio-group>
							</v-flex> -->
              <!-- <v-flex md6>
									<p>Con Compensación</p>
									<v-radio-group v-model="form.compensacion" row>
									<v-radio label="Sí" :value="1"></v-radio>
									<v-radio label="No" :value="0"></v-radio>
									</v-radio-group>
							</v-flex>
							<v-flex md12>
									<p>Elaborado por:</p>
									<v-radio-group v-model="form.id_parametro_elaborado" row>
									<v-radio label="Servidor Público" :value="91"></v-radio>
									<v-radio label="Recursos Humanos" :value="92"></v-radio>
									</v-radio-group>
							</v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      tipo_permiso: []
    };
  },
  mounted() {
    this.$bus.$on("openDialogCrearActualizarTipoPermiso", item => {
      this.form = item;
      this.dialog = true;
      if (item.compensacion == true) {
        this.form.compensacion = 1;
      } else {
        this.form.compensacion = 0;
      }

      if (item.refrigerio == true) {
        this.form.refrigerio = 1;
      } else {
        this.form.refrigerio = 0;
      }
      //console.log(this.form)
    }),
      this.obtenerTipoPermiso();
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async obtenerTipoPermiso() {
      let respuesta = await this.$service.graphql({
        query: `
				query{
					params(tipo:"tipo_permiso"){
					rows{
						id
						valor
					}
					}
				}
				`
      });
      this.tipo_permiso = respuesta.params.rows;
    },
    async save() {
      if (this.form.refrigerio == 1) {
        let a = true;
        this.form.refrigerio = a;
      } else {
        let b = false;
        this.form.refrigerio = b;
      }

      if (this.form.compensacion == 1) {
        let a = true;
        this.form.compensacion = a;
      } else {
        let b = false;
        this.form.compensacion = b;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          if (this.form.id) {
            const id = this.form.id;
            delete this.form.id;
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            delete this.form.estado;
            delete this.form.parametro_tipo_permiso;
            delete this.form.active;
            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $tipo_permiso: EditTipoPermiso!){
									tipoPermisoEdit(id: $id, tipo_permiso: $tipo_permiso){
										id
									}
								}
							`,
              variables: {
                id: id,
                tipo_permiso: this.form
              }
            });
          } else {
            console.log(this.form);
            this.form.id_estado = 19;
            await this.$service.graphql({
              query: `
								mutation add($tipo_permiso: NewTipoPermiso!){
									tipoPermisoAdd(tipo_permiso: $tipo_permiso){
										id
									}
								}
							`,
              variables: {
                tipo_permiso: this.form
              }
            });
          }
        } catch (error) {
          console.log(e);
        }
        this.$message.success();
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/tipo_permiso/dialogs/CrearActualizarTipoPermiso.vue